import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import './Unauthorized.css';

const Unauthorized = () => {
  const { user, isAuthenticated } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Log unauthorized access attempt (same as Unauthorized.aspx.cs lines 20-42)
  useEffect(() => {
    const userEmail = user?.email || 'Anonymous';
    const role = user?.role || 'None';
    const attemptedUrl = location.state?.from?.pathname || 'Unknown';

    console.log(
      `Unauthorized Access Attempt - User: ${userEmail}, Role: ${role}, URL: ${attemptedUrl}`
    );

    // TODO: Add audit log API call if needed
    // await auditAPI.log('UNAUTHORIZED_ACCESS', { user: userEmail, url: attemptedUrl });
  }, [user, location]);

  // Determine home link based on user role (same as Unauthorized.aspx.cs lines 44-81)
  const getHomeUrl = () => {
    if (isAuthenticated && user?.role) {
      const role = user.role.toUpperCase();

      switch (role) {
        case 'SUPERADMIN':
          return '/superadmin/dashboard';
        case 'ADMIN':
          return '/admin-dashboard';
        case 'PPD':
          return '/ppd-dashboard';
        case 'HEADMASTER':
        case 'TEACHER':
          return '/school-dashboard';
        case 'KTC':
          return '/report-district';
        default:
          return '/';
      }
    }
    return '/';
  };

  const handleGoHome = () => {
    navigate(getHomeUrl());
  };

  const handleLoginAgain = () => {
    navigate('/login');
  };

  return (
    <div className="unauthorized-page">
      <div className="unauthorized-container">
        {/* Error Icon (same as Unauthorized.aspx lines 110-112) */}
        <div className="error-icon">
          <i className="fas fa-shield-alt"></i>
        </div>

        {/* Error Title (same as Unauthorized.aspx lines 114-116) */}
        <div className="error-title">
          Access Denied
        </div>

        {/* Error Message (same as Unauthorized.aspx lines 118-120) */}
        <div className="error-message">
          You do not have permission to access this page.
        </div>

        {/* Error Details (same as Unauthorized.aspx lines 122-129) */}
        <div className="error-details">
          <p><strong>Why am I seeing this?</strong></p>
          <ul style={{ marginBottom: 0 }}>
            <li>This page requires SuperAdmin privileges</li>
            <li>Your account does not have sufficient permissions</li>
            <li>You may have been logged out due to inactivity</li>
          </ul>
        </div>

        {/* Navigation Buttons (same as Unauthorized.aspx lines 131-138) */}
        <div className="mt-4">
          <button onClick={handleGoHome} className="btn-home">
            <i className="fas fa-home"></i> Go to Home
          </button>
          <button onClick={handleLoginAgain} className="btn-secondary">
            <i className="fas fa-sign-in-alt"></i> Login Again
          </button>
        </div>

        {/* Help Text (same as Unauthorized.aspx lines 140-145) */}
        <div className="help-text">
          <p className="mb-0">
            <i className="fas fa-info-circle"></i>
            {' '}If you believe you should have access to this page, please contact your system administrator.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Unauthorized;
